// ## italics: true 斜体
// ## blod 加粗
// ## alignment: 'center' 文字居中
// ## alignment: 'justify', 单行字间距相等
// ## width height 宽高
// ## margin: [0, 190, 0, 80] 外边距
// ## opacity: 0.5
// ## pageBreak: 'after' 稍后分页？？
// ## fit: [200, 200] 放在一个矩形内
// ## page numbers 页码
// ## page count 页数
// ##	pageMargins: [ 30, 60, 30, 60 ], 页面边距
export  const reportData = {
	pageMargins: [ 30, 60, 30, 75 ],
	header: [
		// { canvas: [ { type: 'line', x1: 30, y1: 0, x2: 570, y2: 0,lineWidth:0.5 } ] }
	],
	footer:{type:'function', arguments:"currentPage, pageCount",body:`return [
				{ canvas: [ { type: 'line', x1: 30, y1: 0, x2: 570, y2: 0,lineWidth:0.5 } ] },
				{
					columns: [
						{
							text: '页码：'+1 + '/' + 1,
							style:['patientsInfo','titleMargin'],
							alignment: 'right'
						},
					],
					margin: [30,0,30,0]
				}
			];`
	 },//  function(currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount; },
	content: [
		{text:"皮肤科患者医学资料留存及使用知情同意书", alignment: 'center',fontSize: 18,bold: false,margin: [0,5,0,0]},
		{ canvas: [ { type: 'line', x1: 0, y1: 6, x2: 540, y2: 6,lineWidth:0.5 } ] },
		

		{   
            id:"patientsName",
			columns: [
				{
					text: [{text: '患者姓名：',  bold: true}],
					style:'patientsInfo'
				},
				{
					text: [{text: '性别：',  bold: true}],
					style:'patientsInfo'
				},
				{
					text: [{text: '年龄：',  bold: true}],
					style:'patientsInfo'
				},
				{
					text:[{text: '病例号：',  bold: true}],
                    style:'patientsInfo',
                    width:'30%'
				},
			],
			style:['patientsInfo','titleMargin']

		},
		{ canvas: [ { type: 'line', x1: 0, y1: 6, x2: 540, y2: 6,lineWidth:0.5 } ] },
		{
			text:[{text: '知情告知：',fontSize:12,  bold: true}] ,
			style:['patientsInfo','titleMargin']
		},
		{   
            id:"notice",
			columns: [
				{
					text: [{text: '.      为了更全面客观了解、记录您的病情，观察病情的发展变化，以便为您提供更准确的诊断意见和更及时、有效的治疗方案，我们将详细采集并留存您的医学资料（包括病历资料、皮损处照片、动态影像、血液标本以及组织标本等）。这些资料将存入我科室病历库及专业资料库、专业资料平台。',  bold: false}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo'],
		},
		{
			text:[{text: '医学资料留存及使用目的：',fontSize:12,  bold: true}] ,
			style:['patientsInfo','titleMargin']
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '1.主要用于疾病诊断及治疗研讨；'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo'],
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '2.部分资料可能用于医学教学示范、科研以及论文发表等。'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo'],
		},
		{
			text:[{text: '科室承诺：',fontSize:12,  bold: true}] ,
			style:['patientsInfo','titleMargin']
		},
		{   
            id:"notice",
			columns: [
				{
					text: [{text: '.      我们会对您的医学资料妥善保管，并承诺为您保护隐私，您的姓名、身份证号、联系方式、具有明显个人特征并能识别个人的影像资料等均不会出现在公开的医学资料上。涉及肖像时，我们会做隐私保护处理。所有的研究成员和研究申办方都被要求对您的身份保密。您的电子档案保存将会加密，仅供研究人员查阅。为确保研究按照规定进行，必要时，政府管理部门或伦理审查委员会的成员按规定可以在研究单位查阅您的个人资料。这项研究结果发表时，将不会披露您个人的任何资料。感谢您的配合。',  bold: false}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo'],
		},
		{
			text:[{text: '患者知情选择：',fontSize:12,  bold: true}] ,
			style:['patientsInfo','titleMargin']
		},
		{
			ul: [
				{text: '我已经阅读了本知情同意书。',margin: [0,0,0,0]},
				{text: '我有机会提问而且所有问题均已得到解答。',margin: [0,4,0,0]},
				{text: '我本人加入医学资料留存是自愿行为。',margin: [0,4,0,0]},
				{text: '我可以选择不留存医学资料，或者在任何时候通知研究者后删除留存的医学资料而不会遭到歧视或报复，我的任何医疗待遇与权益不会因此而受到影响。',margin: [0,4,0,0]},
				{text: '我将收到一份签过字的“知情同意书”副本。',margin: [0,4,0,0]},
			],
			style:['patientsInfo','textIndent'],
			margin: [20,10,0,0]

		},
		{   
            id:"space",
			columns: [
				{
					text: [{text: ''}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent']
		},
		{ canvas: [ { type: 'line', x1: 0, y1: 6, x2: 540, y2: 6,lineWidth:0.5 } ] },
		{
			text:[{text: '同意：',fontSize:12,  bold: true}] ,
			style:['patientsInfo','titleMargin']
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '.      医师已经将上述医学资料留存的目的以及可能的用途向我详细告知，我已充分了解，我同意接受我的相关医学资料留存在首都医科大学附属北京中医医院皮肤科，并授权委托医院可以在不泄露我个人信息以及隐私的情况下，将我的医学资料用于医疗、科研、教学等用途。'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','titleMargin'],
		},
		{   
            id:"space",
			columns: [
				{
					text: [{text: ''}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent']
		},
		{   
            id:"space",
			columns: [
				{
					text: [{text: ''}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent']
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '患者签字：____________'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent'],
		},
		{   
            id:"space",
			columns: [
				{
					text: [{text: ''}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent']
		},
		{   
            id:"space",
			columns: [
				{
					text: [{text: ''}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent']
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '近亲属（或患者的法定监护人、授权委托人）签字：_____________'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent'],
		},
		{   
            id:"space",
			columns: [
				{
					text: [{text: ''}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent']
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '与患者关系：_______________'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent'],
		},
		{   
            id:"space",
			columns: [
				{
					text: [{text: ''}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent']
		},
		{   
            id:"space",
			columns: [
				{
					text: [{text: ''}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent']
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '签字日期：_______年_____月_____日    时_____分_____            签字地点：______________'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent'],
		},
		{   
            id:"space",
			columns: [
				{
					text: [{text: ''}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent']
		},
		{ canvas: [ { type: 'line', x1: 0, y1: 6, x2: 540, y2: 6,lineWidth:0.5 } ] },
		{
			text:[{text: '医生陈述：',fontSize:12,  bold: true}] ,
			style:['patientsInfo','titleMargin']
		},
		{   
            id:"space",
			columns: [
				{
					text: [{text: ''}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent']
		},
		{   
            id:"space",
			columns: [
				{
					text: [{text: ''}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent']
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '.      我已经告知患者将要留存其医学资料，并且解答了患者关于留存资料的用途以及患者隐私保护的相关问题。'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','titleMargin'],
		},
		{   
            id:"space",
			columns: [
				{
					text: [{text: ''}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent']
		},
		{   
            id:"space",
			columns: [
				{
					text: [{text: ''}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent']
		},
		{   
            id:"space",
			columns: [
				{
					text: [{text: ''}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','textIndent']
		},
		{   
            id:"complaint",
			columns: [
				{
					text: [{text: '医生签名：_______________                   签字日期_______年_____月_____日'}],
					style:['patientsInfo','titleMargin'],
					width:'100%'
				},
			],
			style:['patientsInfo','titleMargin'],
		},
		
		
	],
	styles: {
		title:{
			margin: [30,5],
			fontSize: 12,
			// bold: false
		},
		titleMargin:{
			margin:[0,4,0,0]
		},
		DTT:{
			width:50
		},
		patientsInfo:{
			fontSize: 10
		},
		small: {
			fontSize: 8
		},
		chapter:{
			margin: [0,12,0,0]
		},
		textIndent:{
			margin: [25,0,0,0]
		}
	}
	
};